var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-calendar"},[_c('calendar',{attrs:{"masTasks":_vm.setCalendarTasks(_vm.masTasks),"strCalendarView":_vm.strCalendarView},on:{"prev":_vm.onPrev,"next":_vm.onNext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }